<template>
    <div>
      <v-dialog v-model="proposalGlobalCard">
        <modal-card
          v-if="!loaded"
          @closeProposalDialog="proposalGlobalCard=false"
          @reloadParent="reload_parent($event)"
          @reloadLists="reload_lists($event)"
          @reloadCalendar="reload_calendar($event)"
        />
      </v-dialog>
    </div>
  </template>
  
  
  <script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import ModalCard from './modalCard/modalCard.vue';

    export default {
      props: {
      },

      data: () => ({
        loaded: false,
        proposalGlobalCard: false,
        proposal_id: null,
        need_reload_parent: false,
        need_reload_list: false,
        need_reload_calendar: false,
      }),

      components:{
        ModalCard,
      },

      methods:{  
        ...mapMutations([
          'UPDATE_OVERLAY',
          'UPDATE_BASE_PROPOSAL_ID',
        ]),
        ...mapActions([
          'CLOSE_PROPOSAL_CARD',
          'GET_INPUT_ALL',
        ]),

        reload_parent(){
          this.need_reload_parent = true  // перезагрузка только вызвавшего карточку элемента
        },

        reload_lists(){
          this.need_reload_list = true     // перезагрузка всех элементов, подписанных на событие
        },

        reload_calendar(){
          this.need_reload_calendar = true // перезагрузка элементов с данными календаря
        },

        async open_modal_card() {
          this.UPDATE_OVERLAY(true)
          this.loaded = true
          this.need_reload_parent = false
          this.need_reload_list = false
          this.need_reload_calendar = false
          this.proposalGlobalCard = true
          this.UPDATE_BASE_PROPOSAL_ID(this.proposal_id)
          this.GET_INPUT_ALL(this.proposal_id)
            .then(() => {
              this.UPDATE_OVERLAY(false)
              this.loaded = false
            })
        },
      },

      computed: {
        ...mapGetters([
          'GETTERS_CURRENT_PROPOSAL_ID',
          'GETTERS_SHOW_PROPOSAL_CARD',
        ]),
      },

      watch: {
        proposalGlobalCard(val){
          if(!val){
            this.CLOSE_PROPOSAL_CARD({
              need_reload_parent: this.need_reload_parent,
              need_reload_list: this.need_reload_list,
              need_reload_calendar: this.need_reload_calendar,
            })
          }
        },

        GETTERS_SHOW_PROPOSAL_CARD(val) {
        if (val) {
          this.proposal_id = this.GETTERS_CURRENT_PROPOSAL_ID
          this.open_modal_card()
        }
      },
    }
    }
  </script>
  
  
